var map = {
	"./de/btn-back.png": "lcWT",
	"./en/btn-back.png": "+zz/",
	"./es/btn-back.png": "ZCB+",
	"./fr/btn-back.png": "DxpI",
	"./ja/btn-back.png": "1yBD",
	"./ko/btn-back.png": "LEcX",
	"./pt/btn-back.png": "1z1q",
	"./ru/btn-back.png": "QPzC",
	"./th/btn-back.png": "4wYV",
	"./zh-Hant/btn-back.png": "i+tj"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5mJF";